import React from "react";
import Breadcrumb from "../../breadcrumb";

const Header3Breadcrumb = (props) => {
  const { breadcrumb } = props;
  if (breadcrumb) {
    return (
      <div className="header3-breadcrumb container">
        <Breadcrumb breadcrumb={breadcrumb} />
      </div>
    );
  }
  return null;
};
export default Header3Breadcrumb;
